export var defaultAntdFontFamily = "Segoe UI";
